type PayloadStatusItem = {
    kind?: string | null
    status?: string | null
    url?: unknown
    render?: unknown
}

type RetryableAiRunPayloadItem = PayloadStatusItem & {
    runId?: string | null
    label?: string | null
    tagLabel?: string | null
    message?: string | null
    errorMessage?: unknown
    creatorFailurePreview?: unknown
    onRetry?: unknown
    isRetrying?: boolean
}

const ACTIVE_PAYLOAD_STATUSES = new Set(['pending', 'running', 'started', 'submitted'])

export function isActivePayloadStatus(status?: string | null): boolean {
    return typeof status === 'string' && ACTIVE_PAYLOAD_STATUSES.has(status)
}

export function isSingleActiveStatusPayload(items: PayloadStatusItem[]): boolean {
    const visibleItems = items.filter(Boolean)
    if (visibleItems.length !== 1) return false

    const item = visibleItems[0]
    return item.kind === 'run' && !item.url && !item.render && isActivePayloadStatus(item.status)
}

export function presentRetryingAiRunPayload<T extends RetryableAiRunPayloadItem>(
    item: T,
    retryingAiRunId?: string | null,
): T {
    if (!retryingAiRunId || item.runId !== retryingAiRunId || item.status !== 'failed') {
        return item
    }

    const generationLabel = item.tagLabel || item.label

    return {
        ...item,
        status: 'running',
        message: generationLabel ? `Generating ${generationLabel}` : 'Generating',
        errorMessage: null,
        creatorFailurePreview: null,
        onRetry: undefined,
        isRetrying: true,
    } as T
}
